import { Component, Input } from '@angular/core'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { TooltipComponent } from 'src/app/elements/tooltip/tooltip.component'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PriceSuggestionComponent } from 'src/app/elements/price-suggestion/price-suggestion.component'
import { MatDialog } from '@angular/material/dialog'
import { NgClass } from '@angular/common'

@Component({
  selector: 'app-paynow-buy-buttons',
  imports: [
    ButtonComponent,
    TooltipComponent,
    NgClass,
  ],
  templateUrl: './paynow-buy-buttons.component.html',
  styleUrl: './paynow-buy-buttons.component.sass',
})
export class PaynowBuyButtonsComponent {
  @Input() context!: PageContext<RedirectorPaynowConfig>

  constructor (
    protected dialog: MatDialog,
  ) {
  }

  openPriceSuggest () {
    this.dialog.open(PriceSuggestionComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: { context: this.context },
    })
  }
}
